const Contact = () => {
  return (
    <div>
      <h2>Contact us</h2>
      <form>
        <input
          type="text"
          className="border border-black p-2 m-2"
          placeholder="name"
        />
        <input
          type="text"
          className="border border-black p-2 m-2"
          placeholder="message"
        />
        <button className="border border-black p-2 m-2 bg-gray-100 rounded-md">
          Submit
        </button>
      </form>
    </div>
  );
};
export default Contact;
